export enum StationAssignmentStrategy {
  WAITING_AREA_FIRST = 'WAITING_AREA_FIRST', STATION_FIRST = 'STATION_FIRST'
}
